import { render, staticRenderFns } from "./ModalLoading.vue?vue&type=template&id=23af8e39&scoped=true&"
import script from "./ModalLoading.vue?vue&type=script&lang=js&"
export * from "./ModalLoading.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=23af8e39&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23af8e39",
  null
  
)

export default component.exports